import React from "react";
import Loader from "react-loader-spinner";

function Loading() {
  return <Loader type="Oval" color="#5A6268" height={40} width={40} className="loader" />;
}

export default Loading;
